const STATIC_TRANSLATIONS = {
  hi: {
    'MindEdge Aptitude Test': 'माइंडएज एप्टीट्यूड टेस्ट',
    '5 Sections · 50 Questions · ~45 minutes': '5 अनुभाग · 50 प्रश्न · ~45 मिनट',
    'Quantitative Aptitude': 'मात्रात्मक योग्यता',
    'Logical Reasoning': 'तार्किक तर्क',
    'Verbal Ability': 'मौखिक क्षमता',
    'Data Interpretation': 'डेटा व्याख्या',
    'Abstract Reasoning': 'सार तर्क',
    '10 questions': '10 प्रश्न',
    'Begin Assessment ->': 'आकलन शुरू करें ->',
    'Begin Assessment →': 'आकलन शुरू करें →',
    'NeuroPeak Cognitive Battery': 'न्यूरोपीक संज्ञानात्मक बैटरी',
    '5 Sections · 50 Questions · ~40 minutes': '5 अनुभाग · 50 प्रश्न · ~40 मिनट',
    'Working Memory': 'वर्किंग मेमोरी',
    'Processing Speed': 'प्रसंस्करण गति',
    'Fluid Reasoning': 'प्रवाहशील तर्क',
    'Attention & Focus': 'ध्यान और एकाग्रता',
    'Spatial Intelligence': 'स्थानिक बुद्धिमत्ता',
    'Begin Battery →': 'बैटरी शुरू करें →',
    'ProEdge Skill Assessment': 'प्रोएज स्किल आकलन',
    '5 Sections · 50 Questions · ~50 minutes': '5 अनुभाग · 50 प्रश्न · ~50 मिनट',
    'Technical Knowledge': 'तकनीकी ज्ञान',
    'CS fundamentals, OOP, DBMS, DS&A': 'CS मूलभूत बातें, OOP, DBMS, DS&A',
    'Analytical Thinking': 'विश्लेषणात्मक सोच',
    'Case-based reasoning, root cause analysis': 'केस-आधारित तर्क, मूल कारण विश्लेषण',
    'Communication Skills': 'संचार कौशल',
    'Business writing, email tone, clarity': 'व्यावसायिक लेखन, ईमेल टोन, स्पष्टता',
    'Team & Leadership': 'टीम और नेतृत्व',
    'Collaboration, delegation, conflict resolution': 'सहयोग, जिम्मेदारी बाँटना, विवाद समाधान',
    'Professional Ethics': 'पेशेवर नैतिकता',
    'Integrity, data privacy, ethical dilemmas': 'ईमानदारी, डेटा गोपनीयता, नैतिक दुविधाएँ',
    'Apex All-in-One Mega Bundle': 'एपेक्स ऑल-इन-वन मेगा बंडल',
    '7 Sections · 70 Questions · ~75 minutes · Fully Proctored': '7 अनुभाग · 70 प्रश्न · ~75 मिनट · पूर्ण प्रॉक्टर्ड',
    'Quantitative & Logical': 'मात्रात्मक और तार्किक',
    'Cognitive Battery': 'संज्ञानात्मक बैटरी',
    'Skill & Technical': 'कौशल और तकनीकी',
    'Verbal & Communication': 'मौखिक और संचार',
    'Data & Abstract Reasoning': 'डेटा और सार तर्क',
    'Coding Fundamentals': 'कोडिंग मूलभूत बातें',
    'Situational Judgement': 'परिस्थितिजन्य निर्णय',
    'EXCLUSIVE': 'विशेष',
    '7/7 sections loaded': '7/7 अनुभाग लोड हो गए',
    'Begin Apex Assessment →': 'एपेक्स आकलन शुरू करें →',
    'WorkScore Assessment': 'वर्कस्कोर आकलन',
    'Section': 'अनुभाग',
    'Pool: 50 | Asked': 'पूल: 50 | पूछे गए',
    'Total Time: 90 minutes': 'कुल समय: 90 मिनट',
    'Question Delivery: Random {n} per section from each 50-question pool': 'प्रश्न वितरण: प्रत्येक 50-प्रश्न पूल से प्रति अनुभाग यादृच्छिक {n}',
    'Scoring: Best 10 | Strong 7 | Average 4 | Weak 2 | Poor 0': 'स्कोरिंग: सर्वश्रेष्ठ 10 | मजबूत 7 | औसत 4 | कमजोर 2 | खराब 0',
    'View Rules & Start': 'नियम देखें और शुरू करें',
    'Back': 'वापस',
    'Go Back': 'वापस जाएँ',
    'Assessment not found.': 'आकलन नहीं मिला।',
    'This assessment uses a 250-question pool across 5 sections (50 per section).': 'यह आकलन 5 अनुभागों (प्रति अनुभाग 50) में 250 प्रश्नों के पूल का उपयोग करता है।',
    'For this attempt, a random subset (10 or 12 questions per section) is selected from the pool.': 'इस प्रयास के लिए पूल से एक यादृच्छिक उपसमूह (प्रति अनुभाग 10 या 12 प्रश्न) चुना जाता है।',
    'You cannot go back to a previous question once answered.': 'एक बार उत्तर देने के बाद आप पिछले प्रश्न पर वापस नहीं जा सकते।',
    'You cannot skip questions. Each question must be answered before proceeding.': 'आप प्रश्न छोड़ नहीं सकते। आगे बढ़ने से पहले हर प्रश्न का उत्तर देना आवश्यक है।',
    'You cannot navigate between sections freely. Complete each section fully to unlock the next.': 'आप अनुभागों के बीच स्वतंत्र रूप से नेविगेट नहीं कर सकते। अगले को अनलॉक करने के लिए हर अनुभाग पूरा करें।',
    'The assessment must be completed in full-screen mode. Exiting full-screen will be recorded as a violation.': 'आकलन पूर्ण-स्क्रीन मोड में पूरा करना होगा। फुल-स्क्रीन से बाहर निकलना उल्लंघन के रूप में दर्ज होगा।',
    'Switching browser tabs or minimizing the window is not allowed. 3 violations = auto-submission.': 'ब्राउज़र टैब बदलना या विंडो मिनिमाइज़ करना अनुमति नहीं है। 3 उल्लंघन = स्वतः सबमिशन।',
    'Copy, paste, and right-click are disabled during the assessment.': 'आकलन के दौरान कॉपी, पेस्ट और राइट-क्लिक निष्क्रिय हैं।',
    'Do not use keyboard shortcuts (F12, Ctrl+Shift+I, etc.) during the assessment.': 'आकलन के दौरान कीबोर्ड शॉर्टकट (F12, Ctrl+Shift+I आदि) का उपयोग न करें।',
    'All violations are logged and included in your final report.': 'सभी उल्लंघन लॉग किए जाते हैं और आपकी अंतिम रिपोर्ट में शामिल होते हैं।',
    'Once you submit a section, it is locked. You cannot return to it.': 'एक बार अनुभाग जमा करने पर वह लॉक हो जाता है। आप उस पर वापस नहीं जा सकते।',
    'Ensure a stable internet connection before starting.': 'शुरू करने से पहले स्थिर इंटरनेट कनेक्शन सुनिश्चित करें।',
    'The assessment auto-saves your progress locally. If your browser crashes, you may resume from where you left off.': 'आकलन आपकी प्रगति को स्थानीय रूप से ऑटो-सेव करता है। यदि ब्राउज़र क्रैश हो जाए, तो आप वहीं से फिर शुरू कर सकते हैं।'
  },
  ta: {
    'MindEdge Aptitude Test': 'மைண்ட்எட்ஜ் திறன் தேர்வு',
    '5 Sections · 50 Questions · ~45 minutes': '5 பிரிவுகள் · 50 கேள்விகள் · ~45 நிமிடங்கள்',
    'Quantitative Aptitude': 'அளக்கைத் திறன்',
    'Logical Reasoning': 'தருக்கமான சிந்தனை',
    'Verbal Ability': 'மொழித் திறன்',
    'Data Interpretation': 'தரவு பகுப்பாய்வு',
    'Abstract Reasoning': 'மூலக்கருத்து தருக்கம்',
    '10 questions': '10 கேள்விகள்',
    'Begin Assessment ->': 'தேர்வை தொடங்கு ->',
    'Begin Assessment →': 'தேர்வை தொடங்கு →',
    'NeuroPeak Cognitive Battery': 'நியூரோபீக் அறிவாற்றல் தொகுப்பு',
    '5 Sections · 50 Questions · ~40 minutes': '5 பிரிவுகள் · 50 கேள்விகள் · ~40 நிமிடங்கள்',
    'Working Memory': 'வேலை நினைவகம்',
    'Processing Speed': 'செயலாக்க வேகம்',
    'Fluid Reasoning': 'ஓட்டமான தருக்கம்',
    'Attention & Focus': 'கவனம் மற்றும் ஒருமைப்பாடு',
    'Spatial Intelligence': 'விண்வெளி நுண்ணறிவு',
    'Begin Battery →': 'தொகுப்பை தொடங்கு →',
    'ProEdge Skill Assessment': 'ப்ரோஎட்ஜ் திறன் தேர்வு',
    '5 Sections · 50 Questions · ~50 minutes': '5 பிரிவுகள் · 50 கேள்விகள் · ~50 நிமிடங்கள்',
    'Technical Knowledge': 'தொழில்நுட்ப அறிவு',
    'CS fundamentals, OOP, DBMS, DS&A': 'CS அடிப்படை, OOP, DBMS, DS&A',
    'Analytical Thinking': 'பகுப்பாய்வு சிந்தனை',
    'Case-based reasoning, root cause analysis': 'வழக்குக்கேற்ற தருக்கம், மூல காரணம் பகுப்பாய்வு',
    'Communication Skills': 'தொடர்பு திறன்கள்',
    'Business writing, email tone, clarity': 'வணிக எழுத்து, மின்னஞ்சல் பாணி, தெளிவு',
    'Team & Leadership': 'குழு மற்றும் தலைமைத்துவம்',
    'Collaboration, delegation, conflict resolution': 'ஒத்துழைப்பு, பொறுப்பு பகிர்வு, முரண்பாடு தீர்வு',
    'Professional Ethics': 'தொழில்முறை நெறிமுறைகள்',
    'Integrity, data privacy, ethical dilemmas': 'நேர்மை, தரவு தனியுரிமை, நெறி சிக்கல்கள்',
    'Apex All-in-One Mega Bundle': 'ஏபெக்ஸ் அனைத்தும்-ஒரே மெகா தொகுப்பு',
    '7 Sections · 70 Questions · ~75 minutes · Fully Proctored': '7 பிரிவுகள் · 70 கேள்விகள் · ~75 நிமிடங்கள் · முழுமையான கண்காணிப்பு',
    'Quantitative & Logical': 'அளக்கை மற்றும் தருக்கம்',
    'Cognitive Battery': 'அறிவாற்றல் தொகுப்பு',
    'Skill & Technical': 'திறன் மற்றும் தொழில்நுட்பம்',
    'Verbal & Communication': 'மொழி மற்றும் தொடர்பு',
    'Data & Abstract Reasoning': 'தரவு மற்றும் மூலக்கருத்து தருக்கம்',
    'Coding Fundamentals': 'கோடிங் அடிப்படைகள்',
    'Situational Judgement': 'நிலைமையியல் தீர்மானம்',
    'EXCLUSIVE': 'சிறப்பு',
    '7/7 sections loaded': '7/7 பிரிவுகள் ஏற்றப்பட்டன',
    'Begin Apex Assessment →': 'ஏபெக்ஸ் தேர்வை தொடங்கு →',
    'WorkScore Assessment': 'வர்க்ஸ்கோர் தேர்வு',
    'Section': 'பிரிவு',
    'Pool: 50 | Asked': 'தொகுப்பு: 50 | கேட்கப்பட்டவை',
    'Total Time: 90 minutes': 'மொத்த நேரம்: 90 நிமிடங்கள்',
    'Question Delivery: Random {n} per section from each 50-question pool': 'கேள்வி வழங்கல்: ஒவ்வொரு 50-கேள்வி தொகுப்பிலிருந்தும் பிரிவுக்கு சீரற்ற {n}',
    'Scoring: Best 10 | Strong 7 | Average 4 | Weak 2 | Poor 0': 'மதிப்பீடு: சிறந்தது 10 | வலுவானது 7 | சராசரி 4 | பலவீனம் 2 | குறைவு 0',
    'View Rules & Start': 'விதிகளைப் பார்க்கவும் மற்றும் தொடங்கவும்',
    'Back': 'பின்',
    'Go Back': 'திரும்பிச் செல்லவும்',
    'Assessment not found.': 'தேர்வு கிடைக்கவில்லை.',
    'This assessment uses a 250-question pool across 5 sections (50 per section).': 'இந்த தேர்வு 5 பிரிவுகளில் (ஒவ்வொன்றிலும் 50) 250 கேள்விகளைக் கொண்ட தொகுப்பைப் பயன்படுத்துகிறது.',
    'For this attempt, a random subset (10 or 12 questions per section) is selected from the pool.': 'இந்த முயற்சிக்காக தொகுப்பிலிருந்து சீரற்ற துணைத் தொகுப்பு (ஒவ்வொரு பிரிவுக்கும் 10 அல்லது 12 கேள்விகள்) தேர்வு செய்யப்படுகிறது.',
    'You cannot go back to a previous question once answered.': 'ஒருமுறை பதிலளித்த கேள்விக்கு மீண்டும் செல்ல முடியாது.',
    'You cannot skip questions. Each question must be answered before proceeding.': 'கேள்விகளை தவிர்க்க முடியாது. தொடர்வதற்கு முன் ஒவ்வொரு கேள்விக்கும் பதில் அளிக்க வேண்டும்.',
    'You cannot navigate between sections freely. Complete each section fully to unlock the next.': 'பிரிவுகளுக்கு இடையில் சுதந்திரமாக நகர முடியாது. அடுத்ததை திறக்க ஒவ்வொரு பிரிவையும் முழுமையாக முடிக்கவும்.',
    'The assessment must be completed in full-screen mode. Exiting full-screen will be recorded as a violation.': 'தேர்வு முழுத்திரை முறையில் முடிக்கப்பட வேண்டும். முழுத்திரையிலிருந்து வெளியேறுவது மீறலாக பதிவு செய்யப்படும்.',
    'Switching browser tabs or minimizing the window is not allowed. 3 violations = auto-submission.': 'உலாவி தாவல்களை மாற்றுவது அல்லது சாளரத்தை சுருக்குவது அனுமதிக்கப்படாது. 3 மீறல்கள் = தானியங்கி சமர்ப்பிப்பு.',
    'Copy, paste, and right-click are disabled during the assessment.': 'தேர்வின் போது நகலெடு, ஒட்டு, வலது-கிளிக் ஆகியவை முடக்கப்பட்டிருக்கும்.',
    'Do not use keyboard shortcuts (F12, Ctrl+Shift+I, etc.) during the assessment.': 'தேர்வின் போது விசைப்பலகை குறுக்கு வழிகள் (F12, Ctrl+Shift+I போன்றவை) பயன்படுத்த வேண்டாம்.',
    'All violations are logged and included in your final report.': 'அனைத்து மீறல்களும் பதிவு செய்யப்பட்டு இறுதி அறிக்கையில் சேர்க்கப்படும்.',
    'Once you submit a section, it is locked. You cannot return to it.': 'ஒரு பிரிவை சமர்ப்பித்தவுடன் அது பூட்டப்படும். அதற்கு திரும்ப முடியாது.',
    'Ensure a stable internet connection before starting.': 'தொடங்குவதற்கு முன் நிலையான இணைய இணைப்பை உறுதி செய்யவும்.',
    'The assessment auto-saves your progress locally. If your browser crashes, you may resume from where you left off.': 'தேர்வு உங்கள் முன்னேற்றத்தை உள்ளகமாக தானாக சேமிக்கும். உலாவி செயலிழந்தால், நீங்கள் நிறுத்திய இடத்திலிருந்து தொடரலாம்.'
  }
};

export function translateStaticText(text, lang) {
  if (!text || !lang || lang === 'en') return text;
  return STATIC_TRANSLATIONS[lang]?.[text] || text;
}

export function translateStaticList(texts, lang) {
  if (!Array.isArray(texts)) return [];
  return texts.map((text) => translateStaticText(text, lang));
}
